import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { debounceTime, distinctUntilChanged, Subject, Subscription } from 'rxjs';

@Component({
  selector: 'app-user-search',
  templateUrl: './user-search.component.html',
  styleUrls: ['./user-search.component.scss']
})
export class UserSearchComponent implements OnInit, OnDestroy {
  @Input() searchOptions: any[] = [];
  @Output() searchData = new EventEmitter<any>();

  searchStr: string = '';
  activeCol: { title: string; value: string }[] = [];
  private searchSubscription!: Subscription;
  private searchSubject = new Subject<string>();
  ngOnInit(): void {
    this.searchSubscription = this.searchSubject.pipe(
      debounceTime(500),
      distinctUntilChanged()
    ).subscribe(() => {
      this.emitSearchData()
    })
  }
  ngOnDestroy(): void {
    this.searchSubscription?.unsubscribe()
  }
  changeIndex(event: any) {
    this.activeCol = this.searchOptions.filter(
      (option) => option.value === event
    );
  }

  removeClick() {
    this.searchStr = '';
    this.emitSearchData();
  }

  search() {
    this.emitSearchData();
  }

  onInputChange() {
    this.searchSubject.next(this.searchStr)
  }

  private emitSearchData() {
    this.searchData.emit({
      searchBy: this.activeCol[0]?.value || this.searchOptions[0].value,
      searchText: this.searchStr
    });
  }
}
